import Vue from 'vue'
import dayjs from 'dayjs'

Vue.prototype.$day = dayjs
